import { readCountry } from './country'
import { consentClient, localizationHeader } from './client'

function buildHeaders(idempotencyKey) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Idempotency-Key': idempotencyKey,
    ...localizationHeader(),
  }

  // Held to the same rule as the body field: the contract says locale and country will
  // eventually be read from these headers and ignored in the body, so a value that would be
  // rejected there must not slip in through here either.
  const country = readCountry()
  if (country) {
    headers['X-Country'] = country
  }

  // Sent when we have one so the journal can attribute the decision to a user. The route is
  // public: a missing, broken or expired token all store the consent with user_id null, so
  // there is no 401 to recover from here.
  const token = localStorage.getItem('user_token')
  if (token) {
    headers.Authorization = 'Bearer ' + token
  }

  return headers
}

function readResult(response) {
  const data = (response && response.data && response.data.data) || {}

  return {
    consentId: data.consent_id || data.consentId || null,
    expiresAt: data.expires_at || data.expiresAt || null,
  }
}

export async function postConsent(record) {
  const response = await consentClient.post('v1/cookie-consents', record.body, {
    headers: buildHeaders(record.key),
    // The backend answers with its own `renew_consent` cookie, scoped to the parent domain
    // shared by the site and the API, so the consent survives Safari's seven-day cap on
    // anything JavaScript wrote. Without this the Set-Cookie is discarded: the request is
    // cross-origin, and the CORS config allows credentials for exactly the listed origins.
    withCredentials: true,
  })

  return readResult(response)
}
